import { render, staticRenderFns } from "./DataGrid.vue?vue&type=template&id=57e2fba7&scoped=true"
import script from "./DataGrid.vue?vue&type=script&lang=js"
export * from "./DataGrid.vue?vue&type=script&lang=js"
import style0 from "./DataGrid.vue?vue&type=style&index=0&id=57e2fba7&prod&lang=scss"
import style1 from "./DataGrid.vue?vue&type=style&index=1&id=57e2fba7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e2fba7",
  null
  
)

export default component.exports